module.exports = "/_next/static/images/Hero@2x-307599379e7e41466f40522a5a63e404.webp";